import React from 'react';
export function AboutSection() {
  return <section id="about" className="py-16 bg-white" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="flex flex-col-reverse md:flex-row items-center" data-id="element-23">
          <div className="md:w-1/2 mt-10 md:mt-0 md:pr-8" data-id="element-24">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1Vo3pPx4TJeT8NMbqJXVSQ/Meet_the_Bookkeeper.jpg" alt="Professional bookkeeper" className="w-full h-auto rounded-lg shadow-lg" data-id="element-25" />
          </div>
          <div className="md:w-1/2 md:pl-8" data-id="element-26">
            <h2 className="text-3xl font-bold text-[#3A4A46] mb-6" data-id="element-27">
              Meet Your Bookkeeper & Tax Professional
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-28">
              <span className="font-bold" data-id="element-29">
                Feeling overwhelmed by your books?
              </span>
            </p>
            <p className="text-gray-600 mb-6" data-id="element-30">
              Whether you're just starting out, unsure if your financials are
              accurate, or feeling unprepared for tax time or a lender, you're
              not alone. Many small business owners feel the same way.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-31">
              <span className="font-bold" data-id="element-32">I get it-and I can help.</span>
            </p>
            <p className="text-gray-600 mb-6" data-id="element-33">
              I help small business owners clean up their finances, stay on top
              of the numbers, and actually understand what's going on in their
              business.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-34">
              <span className="font-bold" data-id="element-35">Hi, I'm Jaime.</span>
            </p>
            <p className="text-gray-600 mb-6" data-id="element-36">
              I'm a former lender turned bookkeeper, which means I know exactly
              what banks, lenders, and tax pros want to see-and how to make sure
              your financials are ready for it. With a background in banking,
              finance, and bookkeeping, I bring a unique perspective to
              organizing your numbers and keeping you compliant.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-37">
              <span className="font-bold" data-id="element-38">Here's my approach:</span>
            </p>
            <ol className="list-decimal pl-5 text-gray-600 mb-6" data-id="element-39">
              <li className="mb-2" data-id="element-40">Get your books organized and accurate.</li>
              <li className="mb-2" data-id="element-41">Keep them up-to-date every month.</li>
              <li className="mb-2" data-id="element-42">
                Help you understand your numbers so you can make confident
                decisions.
              </li>
            </ol>
            <p className="text-gray-600 mb-6" data-id="element-43">
              <span className="font-bold" data-id="element-44">The result?</span>
            </p>
            <p className="text-gray-600" data-id="element-45">
              Less stress. More clarity. Confidence in your money-and your
              business.
            </p>
          </div>
        </div>
      </div>
    </section>;
}